import styled from 'styled-components';

const Title = styled.div`
    color: ${props => props.theme.callouts.colors.title};
    font-size: 14px;
    letter-spacing: .5px;
    line-height: 24px;
`;

export default Title;



// WEBPACK FOOTER //
// ./src/components/atoms/callout/Title.js